// src/components/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

function Navbar() {
  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="bg-blue-600 text-white shadow-md no-print">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-xl font-bold">CTE Completer Tracker</Link>
          <div className="flex space-x-6">
            <Link to="/" className="hover:text-blue-200">Dashboard</Link>
            <Link to="/upload" className="hover:text-blue-200">Upload</Link>
            <Link to="/programs" className="hover:text-blue-200">Programs</Link>
            <Link to="/students" className="hover:text-blue-200">Students</Link>
            <Link to="/reports" className="hover:text-blue-200">Reports</Link>
            <Link to="/faq" className="hover:text-blue-200">FAQ</Link>
            <button onClick={handleSignOut} className="hover:text-blue-200">
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
